import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerlogged';
import User from '../../../components/user/user/cadastrar';


function CadUserScreen () {
    return (
        <Fragment>
            <Head titulo="Cadastro de Usuário | Departamento de TI" />
            <Header />
            <User />
            <Footer />
        </Fragment>
    );
}

export default CadUserScreen;